
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import Sidebar from "../SideBar/SideBar";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Grid,
  TextField,
  StepIconProps ,
} from "@mui/material";
import aadhar from '../../Img/aadhar.png'
import { Label } from "@mui/icons-material";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import Aadhaar from "./step/aadhar";
import Pan from "./step/pan";
import Selfiephoto from "./step/selfie-photo";

const steps = ["Aadhaar Verification", "PAN Verification", "Selfie Photo"];

export default function Individualverification() {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());

  const isStepOptional = (step) => step === 11;

  const isStepSkipped = (step) => skipped.has(step);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  // Render sections based on the active step
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Aadhaar activeStep={activeStep} setActiveStep={setActiveStep} />
        );
      case 1:
        return (
          <Pan activeStep={activeStep} setActiveStep={setActiveStep} />
        );
      case 2:
        return (
          <Selfiephoto activeStep={activeStep} setActiveStep={setActiveStep} />
        );
      default:
        return "Unknown Step";
    }
  };


  const CustomStepIcon = (props) => {
    const { active, completed, icon } = props;
  
    const icons = {
      1: <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.79085 4.47209H15.2132C15.7589 4.47209 16.2013 4.02965 16.2013 3.48397V2.81539C16.2013 2.26971 15.7589 1.82727 15.2132 1.82727H14.9084V1.40941C14.9084 0.991549 14.5692 0.652344 14.1514 0.652344H10.8527C10.4349 0.652344 10.0956 0.991549 10.0956 1.40941V1.82727H9.79085C9.24518 1.82727 8.80273 2.26971 8.80273 2.81539V3.48397C8.80273 4.03456 9.24518 4.47209 9.79085 4.47209Z" fill="white" /><path d="M21.7421 3.23828H17.1112V3.48408C17.1112 4.53119 16.2558 5.38658 15.2087 5.38658H9.79127C8.74416 5.38658 7.88878 4.53119 7.88878 3.48408V3.23828H3.25789C1.73392 3.23828 0.5 4.4722 0.5 5.99617V16.5902C0.5 18.1142 1.73392 19.3481 3.25789 19.3481H21.7421C23.2661 19.3481 24.5 18.1142 24.5 16.5902V5.99617C24.5 4.47712 23.2661 3.23828 21.7421 3.23828ZM7.40701 16.0691C4.77202 16.0691 2.63355 13.9306 2.63355 11.2956C2.63355 8.66065 4.77202 6.52218 7.40701 6.52218C10.042 6.52218 12.1805 8.66065 12.1805 11.2956C12.1805 13.9306 10.0469 16.0691 7.40701 16.0691ZM21.806 13.9749H13.7487V12.9474H21.8011V13.9749H21.806ZM21.806 11.8069H13.7487V10.7795H21.8011V11.8069H21.806ZM21.806 9.63894H13.7487V8.61149H21.8011V9.63894H21.806Z" fill="white" /><path d="M7.42154 7.44141C5.29291 7.44141 3.56738 9.16693 3.56738 11.2956C3.56738 12.2099 3.88692 13.0506 4.41785 13.7093C4.45227 13.3996 4.585 13.0457 4.97828 12.9473C5.73535 12.7556 6.34985 12.323 6.34985 12.323L6.92011 14.1223L6.99876 14.3681L7.2544 13.6454C6.61531 12.7556 7.42154 12.79 7.42154 12.79C7.42154 12.79 8.22777 12.7556 7.58869 13.6454L7.8394 14.3632L7.91806 14.1223V14.1272L8.00655 13.8421L8.4834 12.3279C8.4834 12.3279 9.0979 12.7605 9.85497 12.9523C10.2483 13.0506 10.381 13.4045 10.4154 13.7142C10.9463 13.0555 11.2659 12.2149 11.2659 11.3005C11.2757 9.16693 9.55018 7.44141 7.42154 7.44141ZM8.94551 10.8433C8.84719 11.1972 8.74887 11.3005 8.68004 11.3054C8.61613 11.7282 8.27693 12.264 7.75091 12.4557C7.52969 12.5344 7.28881 12.5344 7.06759 12.4557C6.53174 12.264 6.20237 11.7282 6.13846 11.3054C6.06964 11.3005 5.97132 11.2022 5.873 10.8433C5.73535 10.3566 5.88283 10.2829 6.00573 10.2976C5.98115 10.2288 5.9664 10.1649 5.95165 10.0961C5.90741 9.86992 5.89758 9.65853 5.94674 9.45206C6.01064 9.18168 6.15812 8.96537 6.32035 8.79331C6.42359 8.68516 6.54157 8.58684 6.66447 8.50818C6.76771 8.43936 6.88078 8.37545 6.99876 8.33612C7.09708 8.30171 7.1954 8.28205 7.30356 8.27713C7.63785 8.24763 7.88856 8.33121 8.07046 8.43936C8.34084 8.58684 8.44407 8.78839 8.44407 8.78839C8.44407 8.78839 9.06349 8.83264 8.85702 10.0961C8.84719 10.16 8.82752 10.2288 8.80294 10.2976C8.93567 10.2878 9.08316 10.3566 8.94551 10.8433Z" fill="white" /></svg>,
      2: <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.25 9.875C7.62863 9.875 7.125 10.3786 7.125 11V11.75C7.125 12.3714 7.62863 12.875 8.25 12.875C8.87137 12.875 9.375 12.3714 9.375 11.75V11C9.375 10.3786 8.87137 9.875 8.25 9.875Z" fill="white" /><path d="M8.25 7.625C5.76487 7.625 3.75 9.63987 3.75 12.125C3.75 13.277 4.18688 14.3251 4.899 15.1209C5.37863 14.4972 6.38025 13.625 8.25 13.625C7.21425 13.625 6.375 12.7857 6.375 11.75V11C6.375 9.96425 7.21425 9.125 8.25 9.125C9.28575 9.125 10.125 9.96425 10.125 11V11.75C10.125 12.7857 9.28575 13.625 8.25 13.625C10.1198 13.625 11.1214 14.4972 11.601 15.1209C12.3131 14.3251 12.75 13.277 12.75 12.125C12.75 9.63987 10.7351 7.625 8.25 7.625Z" fill="white" /><path d="M8.24994 14.375C6.61456 14.375 5.79631 15.155 5.44531 15.6403C6.21444 16.2553 7.18831 16.625 8.24994 16.625C9.31156 16.625 10.2854 16.2553 11.0549 15.6403C10.7043 15.1558 9.88606 14.375 8.24994 14.375Z" fill="white" /><path d="M22.5 3.125H19.5V1.25C19.5 1.04263 19.3324 0.875 19.125 0.875H16.875C16.6676 0.875 16.5 1.04263 16.5 1.25V3.125H7.5V1.25C7.5 1.04263 7.33238 0.875 7.125 0.875H4.875C4.66762 0.875 4.5 1.04263 4.5 1.25V3.125H1.5C0.670875 3.125 0 3.79588 0 4.625V19.625C0 20.4541 0.670875 21.125 1.5 21.125H22.5C23.3291 21.125 24 20.4541 24 19.625V4.625C24 3.79588 23.3291 3.125 22.5 3.125ZM17.25 1.625H18.75V4.625H17.25V1.625ZM15.375 8.375H17.625C17.8324 8.375 18 8.54262 18 8.75C18 8.95737 17.8324 9.125 17.625 9.125H15.375C15.1676 9.125 15 8.95737 15 8.75C15 8.54262 15.1676 8.375 15.375 8.375ZM5.25 1.625H6.75V4.625H5.25V1.625ZM8.25 17.375C5.35087 17.375 3 15.0241 3 12.125C3 9.22587 5.35087 6.875 8.25 6.875C11.1491 6.875 13.5 9.22587 13.5 12.125C13.5 15.0241 11.1491 17.375 8.25 17.375ZM20.625 15.875H15.375C15.1676 15.875 15 15.7074 15 15.5C15 15.2926 15.1676 15.125 15.375 15.125H20.625C20.8324 15.125 21 15.2926 21 15.5C21 15.7074 20.8324 15.875 20.625 15.875ZM15 13.25C15 13.0426 15.1676 12.875 15.375 12.875H19.125C19.3324 12.875 19.5 13.0426 19.5 13.25C19.5 13.4574 19.3324 13.625 19.125 13.625H15.375C15.1676 13.625 15 13.4574 15 13.25ZM20.625 11.375H15.375C15.1676 11.375 15 11.2074 15 11C15 10.7926 15.1676 10.625 15.375 10.625H20.625C20.8324 10.625 21 10.7926 21 11C21 11.2074 20.8324 11.375 20.625 11.375Z" fill="white" /></svg>,
      3: <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.0537 3.27857H12.3126V1.55879C12.3126 0.873742 11.7572 0.318359 11.0722 0.318359H6.0353C5.35026 0.318359 4.79487 0.873742 4.79487 1.55879V3.27865H1.94628C1.14752 3.27857 0.5 3.92609 0.5 4.72486V18.2349C0.5 19.0338 1.14752 19.6813 1.94628 19.6813H23.0537C23.8525 19.6813 24.5 19.0338 24.5 18.2349V4.72486C24.5 3.92609 23.8525 3.27857 23.0537 3.27857ZM17.547 15.2994C17.547 15.9254 17.0395 16.4329 16.4135 16.4329H4.46918C3.84325 16.4329 3.3357 15.9254 3.3357 15.2994V7.66035C3.3357 7.03441 3.84325 6.52687 4.46918 6.52687H16.4135C17.0395 6.52687 17.547 7.03441 17.547 7.66035V15.2994ZM20.9522 11.7609C20.3961 11.7609 19.9452 11.31 19.9452 10.7538C19.9452 10.1977 20.3961 9.74681 20.9522 9.74681C21.5084 9.74681 21.9593 10.1977 21.9593 10.7538C21.9593 11.31 21.5085 11.7609 20.9522 11.7609ZM20.9522 7.88496C20.3961 7.88496 19.9452 7.43404 19.9452 6.87793C19.9452 6.32182 20.3961 5.87098 20.9522 5.87098C21.5084 5.87098 21.9593 6.32182 21.9593 6.87793C21.9593 7.43412 21.5085 7.88496 20.9522 7.88496Z" fill="white" /><path d="M10.4409 12.1231C9.64089 12.1231 8.91533 11.7998 8.38701 11.2773C7.91764 11.7797 7.62988 12.4538 7.62988 13.1956V15.0279C7.62988 15.3146 7.86231 15.5469 8.14894 15.5469H12.7328C13.0194 15.5469 13.2518 15.3145 13.2518 15.0279V13.1956C13.2518 12.4538 12.9641 11.7797 12.4948 11.2774C11.9666 11.7999 11.2408 12.1231 10.4409 12.1231Z" fill="white" /><path d="M10.4414 10.9141C11.3885 10.9141 12.1563 10.1463 12.1563 9.19925C12.1563 8.25215 11.3885 7.48438 10.4414 7.48438C9.49434 7.48438 8.72656 8.25215 8.72656 9.19925C8.72656 10.1463 9.49434 10.9141 10.4414 10.9141Z" fill="white" /></svg>,
    };

    // if (icon === 2 || icon === 3) {
    //   return null;
    // }
  
    return (
      <div
        style={{
          // color: active ? "#4caf50" : completed ? "#757de8" : "#bdbdbd",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: active ? "#566FFF" : completed ? "#566FFF" : "#090909",
          // background: active && completed ? "#566FFF" :"#090909",
          borderRadius:"100px",
          width: "40px",
          height:"40px"
        }}
        className="round_stepper"
      >
        {icons[String(props.icon)]}
      </div>
    );
  };



  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 19,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor:"#566FFF"

      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor:"#566FFF"
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 4,
      border: 0,
      backgroundColor: '#eaeaf0',
      // background:"linear-gradient(90deg, #566FFF 10%, #D9D9D9 20%)",
      borderRadius: 1,
      ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey[800],
      }),
    },
  }));

  return (
    <div>
      <Header />
      <div className="main_flx">
      <Sidebar />
      <div style={{width:"100%"}} >
      <div className="abvbar split_half">
        <h6>Individual Identity Verification</h6>
      </div>
      <div className="split_half mt-30">
        <div className="verify_points">
        <Box sx={{ width: { xl: "80%" }, margin: "auto" }} >
          <Stepper alternativeLabel  activeStep={activeStep} connector={<ColorlibConnector />} sx={{marginBottom:"100px"}}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              if (isStepOptional(index)) {
                labelProps.optional = <Typography variant="caption">Optional</Typography>;
              }
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps} StepIconComponent={CustomStepIcon}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you're finished
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button onClick={handleReset}>Reset</Button>
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                {renderStepContent(activeStep)}
              </Typography>
              {/* <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Button
                  color="inherit"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
                {isStepOptional(activeStep) && (
                  <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                    Skip
                  </Button>
                )}
                <Button onClick={handleNext}>
                  {activeStep === steps.length - 1 ? "Finish" : "Next"}
                </Button>
              </Box> */}
            </React.Fragment>
          )}
        </Box>
      </div>
      </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
